var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92.08 92.28"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.31 0a37.31 37.31 0 1037.31 37.31A37.36 37.36 0 0037.31 0zm0 66.42a29.11 29.11 0 1129.11-29.11 29.14 29.14 0 01-29.11 29.11zm54.18 19.64l.09-.09-19.35-19.35-.82-.81-.17.16a4 4 0 00-1.77-.41 4.1 4.1 0 00-3.71 5.85l-.17.17 19.49 19.5.11.11.57.56.07-.08a4 4 0 002.15.61 4.1 4.1 0 003.51-6.22z",
    fill: "#d9d9d9",
    "data-name": "Artwork 1"
  })))));
}
export default SvgMagGlass;